import { PublicConfig, PublicEnvironment } from '../../models/environment.public';
import { commonEnvVars, stagingEnv } from 'src/common/environments/environment.public.common';

const { features, gatewayPath, ...rest } = stagingEnv;

const config: PublicConfig = {
    appId: 'l769f16362b98e4b67a96461a78b0d81b6',
    appziSrc: `https://w.appzi.io/w.js?token=VYeEM`,
    brand: 'Totaline',
    brandPath: 'totaline',
    gatewayPath,
    publicBaseUrl: 'https://staging-totaline.hvacpartners.com',
    siteCode: 1095,
    features: {
        ...features,
        newsLetterSignUp: false,
        auth: {
            login: true,
            externalLogin: false
        }
    },
    ...rest
};

const { api, ...all } = commonEnvVars(config);

const totalineConfig: PublicEnvironment = {
    captchaKey: '6LcQ5M4iAAAAAOMQp0qeeoFl3wykDcI7T29OCY38',
    api: {
        ...api,
        crossReference: {
            categories: `${gatewayPath}/public/totaline/xref/allcategories?fields=BASIC&includeSubCategories=true`,
            categoryQuery: `${gatewayPath}/public/totaline/xref/categories/`,
            suggest: 'crossReferences/suggest',
            crossReferenceProductSearch: `${gatewayPath}/public/totaline/xref/crossreferences/search`,
            crossReferenceFilterSearch: `${gatewayPath}/public/totaline/xref/crossreferences/bottom-filters`,
            productDetail: `${gatewayPath}/public/totaline/xref/product`
        },
        captcha: `${gatewayPath}/public/hvac/account/user/recaptcha/verify?`
    },
    ...all
};


export const environment: PublicEnvironment = totalineConfig;
